<div class="shell-skeleton" aria-busy="true" aria-label="Loading application">

  <!-- ── Header (np-header) ──
       min-height:110px, padding-top:13px, background: header-bg.jpg
       #sitename: centered block, padding 0 100px
       #hallmark: 50×49px, background-size:42×46px, margin:0 auto
       #sitename>div (title): height:41px, color:#009dd9
  ── -->
  <div class="shell-header">
    <!-- #sitename -->
    <div class="shell-sitename">
      <!-- #hallmark placeholder -->
      <div class="shell-hallmark"></div>
      <!-- site title -->
      <div class="shell-sitename__title">
        <app-skeleton width="220px" height="20px" borderRadius="3px" marginBottom="0" class="skl-teal"></app-skeleton>
      </div>
    </div>
    <!-- header-user-info (position:absolute, right:1.5rem) -->
    <div class="shell-header-user">
      <app-skeleton width="150px" height="14px" borderRadius="3px" marginBottom="5px" class="skl-white"></app-skeleton>
      <app-skeleton width="96px" height="11px" borderRadius="3px" marginBottom="0" class="skl-white-dim"></app-skeleton>
    </div>
  </div>

  <!-- ── nav#site-specific-nav ──
       background:#0b2d71, li>a padding:12.5px 19px → total ~45px
  ── -->
  <nav class="shell-nav" aria-hidden="true">
    @for (item of navItems; track item) {
      <div class="shell-nav__item">
        <app-skeleton
          [width]="item === 1 ? '62px' : item === 2 ? '104px' : item === 3 ? '86px' : item === 4 ? '122px' : '74px'"
          height="21px" borderRadius="3px" marginBottom="0" class="skl-nav"></app-skeleton>
      </div>
    }
  </nav>

  <!-- ── Main content area ── -->
  <div class="shell-content container-fluid py-3 px-4">

    <!-- Applications page skeleton -->
    @if (pageType === 'applications') {
      <app-applications-skeleton></app-applications-skeleton>
    }

    <!-- Assessment detail page skeleton -->
    @if (pageType === 'assessment') {
      <app-assessment-detail-skeleton></app-assessment-detail-skeleton>
    }

    <!-- Dashboard skeleton (default for / and /dashboard) -->
    @if (pageType === 'dashboard') {
      <!-- Page header text -->
      <div class="text-center mb-4">
        <app-skeleton width="320px" height="18px" borderRadius="6px" marginBottom="0" class="d-inline-block"></app-skeleton>
      </div>

      <!-- Top wide card (strategy distribution) -->
      <div class="shell-card mb-3">
        <div class="shell-card__header">
          <app-skeleton width="180px" height="16px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="shell-card__body">
          <div class="shell-kpi-grid">
            @for (c of contentCards; track c) {
              <div class="shell-kpi-item">
                <app-skeleton width="70%" height="12px" borderRadius="3px" marginBottom="10px"></app-skeleton>
                <app-skeleton width="45%" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
              </div>
            }
          </div>
          <app-skeleton width="100%" height="40px" borderRadius="6px" marginBottom="0" class="d-block mt-3"></app-skeleton>
        </div>
      </div>

      <!-- Bottom 2-column cards -->
      <div class="row g-3">
        @for (col of contentCards.slice(0, 2); track col) {
          <div class="col-12 col-xl-6">
            <div class="shell-card h-100">
              <div class="shell-card__header shell-card__header--blue">
                <app-skeleton width="55%" height="14px" borderRadius="4px" marginBottom="0" class="skl-white"></app-skeleton>
              </div>
              <div class="shell-card__body p-0">
                @for (row of [1,2,3,4,5]; track row) {
                  <div class="shell-table-row">
                    <app-skeleton width="80%" height="12px" borderRadius="3px" marginBottom="4px"></app-skeleton>
                    <app-skeleton width="55%" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Generic fallback (admin pages, etc.) -->
    @if (pageType === 'generic') {
      <div class="shell-card mb-3">
        <div class="shell-card__header">
          <app-skeleton width="140px" height="16px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="shell-card__body">
          @for (row of [1,2,3,4,5,6,7,8]; track row) {
            <app-skeleton width="100%" height="14px" borderRadius="3px" marginBottom="12px" class="d-block"></app-skeleton>
          }
        </div>
      </div>
    }

  </div>

</div>
